import React from "react";
import { useSelector } from "react-redux";
import "../HalfPageDesign/design.css";

function HalfPageDesign(props) {
  const themeImage = window.sessionStorage.getItem("theme_landing_image");
  return (
    <>
      <div
        className="bg-img-109"
        style={{
          backgroundImage: `url('${themeImage}')`,
        }}
      ></div>
      <div
        className="container "
        style={{ fontFamily: "'Montserrat', sans-serif" }}
      >
        <div className="row">
          <div className="col-md-8 p-5 bg-color mt-5">{props.innerDesign}</div>
        </div>
      </div>
    </>
  );
}
export default HalfPageDesign;
